import React from 'react';
import OptionList from './optionList';
import logout from '../assets/logout.svg';
import { connect } from 'react-redux';
import { withRouter } from './withRouter';
import { withAuth } from './withAuth';
import PropTypes from 'prop-types';
import logo from '../assets/logo.svg';

class Sidebar extends React.Component {
  render() {
    return (
      <div id='nav' className='col-12 col-md-3 col-xl-2 bd-sidebar'>
        <div className='row'>
          <div className='col-md-12 d-flex align-items-center'>
            <img src={logo} className='h-6 w-6 mr-2' />
            <div className='text-md-center logo'>SUIVI CONSO</div>
          </div>
          <div className='col-md-12 col-4 text-right'>
            {/* <!-- for menu when screen width is less--> */}
            <button
              className='btn btn-link bd-search-docs-toggle d-md-none p-0 ml-3 collapsed'
              type='button'
              data-toggle='collapse'
              data-target='#bd-docs-nav'
              aria-controls='bd-docs-nav'
              aria-expanded='false'
              aria-label='Toggle docs navigation'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 30 30'
                width='30'
                height='30'
                focusable='false'
              >
                <title>Menu</title>
                <path
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeMiterlimit='10'
                  d='M4 7h22M4 15h22M4 23h22'
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <nav className='collapse bd-links' id='bd-docs-nav'>
          <OptionList />
        </nav>
        <div
          className='ms-8 d-flex align-items-center justify-content-center h-20 cursor-pointer text-red-500'
          onClick={() => {
            window.location.href = '/login';
          }}
        >
          <img src={logout} alt='Logout' className='h-6 w-6 mr-2' />
        </div>
      </div>
    );
  }
}
export default Sidebar;
